"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DsSource = void 0;
var _react = _interopRequireWildcard(require("react"));
var _datasyncCore = require("datasync-core");
var _datasyncCommonLibrary = require("datasync-common-library");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class DsSource extends _react.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount = async () => {
    //Let us fetch item from remote database   
    if (this.props.session_guid) this.refreshDataSyncSource(this.props.one_block_pull ? this.props.one_block_pull : true);else console.error("25:this.props.session_guid not set !!!");
  };
  refreshDataSyncSource = p_bool_one_block_pull => {
    (0, _datasyncCore.GetDatasyncMediaOneBlock)({
      session_guid: this.props.session_guid,
      date_synchro: this.props.date_synchro,
      company_guid: this.props.company_guid,
      datasync_url: this.props.datasync_url,
      syncSeekUrl: (0, _datasyncCommonLibrary.SyncSeekUrl)(this.props.datasync_url),
      SyncPullSerializedGETurl: (0, _datasyncCommonLibrary.SyncPullSerializedUrl)(this.props.datasync_url),
      seek_filter_clause: this.props.seek_filter_clause,
      table_guid: this.props.table_guid,
      debugging: false,
      on_media_count_callback: available_items => {
        if (this.props.debugging) console.log("DsSource::on_media_count_callback Items:", available_items);
        if (this.props.onAvailableItemsCount) this.props.onAvailableItemsCount(available_items);
      },
      on_media_ready_callback: items_data => {
        if (this.props.debugging) console.log("DsSource::on_media_ready_callback=>", items_data);
        if (this.props.onDataIsReady) this.props.onDataIsReady(items_data);
      },
      on_media_failed_callback: error_message => {
        if (this.props.debugging) console.log("DsSource::on_media_failed_callback=>", error_message);
        if (this.props.onDataError) this.props.onDataError(error_message);
      },
      one_block_pull: p_bool_one_block_pull
    });
  };

  /** Enforce data dowload as session_guid changes */
  /*
  componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if (this.props.session_guid !== prevProps.session_guid) {
          //Lookup field props has changed
          if (globals.parameters.debugging)
            console.log("25:componentDidUpdate -> has changed", this.props.session_guid)
            this.refreshDataSyncTable(true)
      }
  }*/

  render() {
    return /*#__PURE__*/_react.default.createElement("div", null);
  }
}
exports.DsSource = DsSource;